// extracted by mini-css-extract-plugin
export default {"Dashboard":"Dashboard_Dashboard"};